import { gql } from "@apollo/client";

export interface TmsVehicleType {
  id: number;
  vehicleModelId: number;
  vehicleNumber: string;
  licensePlate: string;
  carrierId: number;
  maxWeightLbs?: number;
  maxVolumeFt3?: number;
  lengthFt?: number;
  widthFt?: number;
  heightFt?: number;
  fuelType: number;
  vehiclePhotos?: string[];
  status: number;
  notes?: string;
  vehicleModelName?: string;
  carrierName?: string;
  fuelTypeName?: string;
  vehicleTypeId?: number;
  vehicleTypeName?: string;
}

export interface TmsVehicleTypeDetail {
  id: number;
  vehicleModelId: number;
  vehicleNumber: string;
  licensePlate: string;
  carrierId: number;
  maxWeightLbs?: number;
  maxVolumeFt3?: number;
  lengthFt?: number;
  widthFt?: number;
  heightFt?: number;
  fuelType: number;
  vehiclePhotos?: string[];
  status: number;
  notes?: string;
  vehiclePhotoUrls?: string[];
  vehicleModelName?: string;
  carrierName?: string;
  fuelTypeName?: string;
  vehicleTypeId?: number;
  vehicleTypeName?: string;
}

export const TMS_VEHICLE_TYPE_DETAIL_FIELDS = gql`
  fragment VehicleTypeDetailFields on TmsVehicleType {
    id
    vehicleModelId
    vehicleNumber
    licensePlate
    carrierId
    maxWeightLbs
    maxVolumeFt3
    lengthFt
    widthFt
    heightFt
    fuelType
    vehicleModelName
    carrierName
    fuelTypeName
    vehiclePhotos
    status
    notes
    vehiclePhotoUrls
    vehicleTypeId
    vehicleTypeName
  }
`;

export const TMS_VEHICLE_TYPE_FIELDS = gql`
  fragment VehicleTypeFields on TmsVehicleType {
    id
    vehicleModelId
    vehicleNumber
    licensePlate
    carrierId
    maxWeightLbs
    maxVolumeFt3
    lengthFt
    widthFt
    heightFt
    fuelType
    vehicleModelName
    carrierName
    fuelTypeName
    vehiclePhotos
    status
    notes
    vehicleTypeId
    vehicleTypeName
  }
`;